export default "__VITE_ASSET__BFfFDHhg__"